export type CustomerNumber = string;
export const PATTERN = /^\d+$/;
